import {LABELS} from '../constants/labels'
import type {IssueFieldRemovedEventNode} from './issue-viewer-page-query-types'
import type {IssueFieldAddedEventFragment} from './IssueFieldAddedEvent'
import type {IssueFieldChangedEventFragment} from './IssueFieldChangedEvent'
import {IssueFieldEvent, type IssueFieldEventBaseProps} from './IssueFieldEvent'
import {RolledupIssueFieldEvent} from './RolledupIssueFieldEvent'

type IssueFieldEventKey = IssueFieldAddedEventFragment | IssueFieldChangedEventFragment | IssueFieldRemovedEventFragment

export type IssueFieldRemovedEventFragment = Pick<
  IssueFieldRemovedEventNode,
  'actor' | 'createdAt' | 'databaseId' | 'intent' | 'issueField'
>

type IssueFieldRemovedEventProps = IssueFieldEventBaseProps & {
  queryRef: IssueFieldRemovedEventFragment
  rollupGroup?: Record<string, IssueFieldEventKey[]>
}

export function IssueFieldRemovedEvent({queryRef, rollupGroup, ...props}: IssueFieldRemovedEventProps) {
  const {actor, createdAt, issueField, databaseId, intent} = queryRef

  const rollupContent = rollupGroup ? (
    <RolledupIssueFieldEvent rollupGroup={rollupGroup} repositoryNameWithOwner={props.repositoryNameWithOwner} />
  ) : undefined

  return (
    <IssueFieldEvent
      actor={actor}
      createdAt={createdAt}
      fieldName={issueField?.name}
      dataType={issueField?.dataType}
      databaseId={databaseId}
      leadingLabel={rollupGroup ? undefined : LABELS.timeline.issueFieldRemoved.leading}
      hasValue={false}
      rollupContent={rollupContent}
      rationale={rollupGroup ? undefined : (intent?.rationale ?? undefined)}
      analyticsAction="ISSUE_FIELD_REMOVED"
      {...props}
    />
  )
}
